export const CODE_LANGUAGES: { [key: string]: { textValue: string; mime: string; mode?: string } } = {
  plain: {
    textValue: 'Plain Text',
    mime: 'text/plain',
  },
  apl: {
    textValue: 'APL',
    mime: 'text/apl',
  },
  aspx: {
    textValue: 'ASP.NET',
    mime: 'application/x-aspx',
  },
  'c++': {
    textValue: 'C++',
    mime: 'text/x-c++src',
  },
  c: {
    textValue: 'C',
    mime: 'text/x-csrc',
  },
  clojure: {
    textValue: 'Clojure',
    mime: 'text/x-clojure',
  },
  cmake: {
    textValue: 'CMake',
    mime: 'text/x-cmake',
  },
  cobol: {
    textValue: 'Cobol',
    mime: 'text/x-cobol',
  },
  coffeescript: {
    textValue: 'CoffeeScript',
    mime: 'text/x-coffeescript',
  },
  'common-lisp': {
    textValue: 'Common Lisp',
    mime: 'text/x-common-lisp',
  },
  csharp: {
    textValue: 'C#',
    mime: 'text/x-csharp',
  },
  css: {
    textValue: 'CSS',
    mime: 'text/css',
  },
  d: {
    textValue: 'D',
    mime: 'text/x-d',
  },
  dart: {
    textValue: 'Dart',
    mime: 'application/dart',
  },
  diff: {
    textValue: 'Diff',
    mime: 'text/x-diff',
  },
  django: {
    textValue: 'Django',
    mime: 'text/x-django',
  },
  'django-html': {
    textValue: 'Django/html',
    mime: 'text/html',
    mode: 'django',
  },
  dockerfile: {
    textValue: 'Dockerfile',
    mime: 'text/x-dockerfile',
  },
  dtd: {
    textValue: 'DTD',
    mime: 'application/xml-dtd',
  },
  dylan: {
    textValue: 'Dylan',
    mime: 'text/x-dylan',
  },
  ebnf: {
    textValue: 'EBNF',
    mime: 'text/x-ebnf',
  },
  ecl: {
    textValue: 'ECL',
    mime: 'text/x-ecl',
  },
  ejs: {
    textValue: 'EJS',
    mime: 'application/x-ejs',
  },
  elixir: {
    textValue: 'Elixir',
    mime: 'text/x-elixir',
    mode: 'elixir',
  },
  elm: {
    textValue: 'Elm',
    mime: 'text/x-elm',
  },
  erb: {
    textValue: 'ERB',
    mime: 'application/x-erb',
  },
  erlang: {
    textValue: 'Erlang',
    mime: 'text/x-erlang',
  },
  fcl: {
    textValue: 'FCL',
    mime: 'text/x-fcl',
  },
  forth: {
    textValue: 'Forth',
    mime: 'text/x-forth',
  },
  fortran: {
    textValue: 'Fortran',
    mime: 'text/x-fortran',
  },
  fsharp: {
    textValue: 'F#',
    mime: 'text/x-fsharp',
  },
  gherkin: {
    textValue: 'Gherkin',
    mime: 'text/x-feature',
  },
  go: {
    textValue: 'Go',
    mime: 'text/x-go',
  },
  graphql: {
    textValue: 'GraphQL',
    mime: 'application/graphql',
  },
  groovy: {
    textValue: 'Groovy',
    mime: 'text/x-groovy',
  },
  handlebars: {
    textValue: 'Handlebars',
    mime: 'text/x-handlebars-template',
  },
  haskell: {
    textValue: 'Haskell',
    mime: 'text/x-haskell',
  },
  'haskell-literate': {
    textValue: 'Haskell-literate (LHS)',
    mime: 'text/x-literate-haskell',
  },
  haxe: {
    textValue: 'Haxe',
    mime: 'text/x-haxe',
  },
  html: {
    textValue: 'HTML',
    mime: 'text/html',
  },
  http: {
    textValue: 'HTTP',
    mime: 'message/http',
  },
  hxml: {
    textValue: 'HXML',
    mime: 'text/x-hxml',
  },
  idl: {
    textValue: 'IDL',
    mime: 'text/x-idl',
  },
  ini: {
    textValue: 'INI',
    mime: 'text/x-properties',
  },
  jade: {
    textValue: 'Jade',
    mime: 'text/x-jade',
  },
  java: {
    textValue: 'Java',
    mime: 'text/x-JAVA',
  },
  javascript: {
    textValue: 'JavaScript/ecmascript',
    mime: 'application/x-javascript',
  },
  json: {
    textValue: 'JSON',
    mime: 'application/json',
  },
  jsp: {
    textValue: 'JSP',
    mime: 'application/x-jsp',
  },
  jsx: {
    textValue: 'JSX',
    mime: 'text/jsx',
  },
  julia: {
    textValue: 'Julia',
    mime: 'text/x-julia',
  },
  kotlin: {
    textValue: 'Kotlin',
    mime: 'text/x-kotlin',
  },
  latex: {
    textValue: 'LaTeX',
    mime: 'text/x-latex',
  },
  less: {
    textValue: 'LESS',
    mime: 'text/x-less',
  },
  livescript: {
    textValue: 'LiveScript',
    mime: 'text/x-livescript',
  },
  lua: {
    textValue: 'Lua',
    mime: 'text/x-lua',
  },
  mariadb: {
    textValue: 'SQL/mariadb',
    mime: 'text/x-mariadb',
  },
  markdown: {
    textValue: 'Markdown (raw)',
    mime: 'text/x-markdown',
  },
  mathematica: {
    textValue: 'Mathematica',
    mime: 'text/x-mathematica',
  },
  mediawiki: {
    textValue: 'MediaWiki',
    mime: 'text/x-mediawiki',
  },
  modelica: {
    textValue: 'Modelica',
    mime: 'text/x-modelica',
  },
  mssql: {
    textValue: 'SQL/mssql',
    mime: 'text/x-mssql',
  },
  mumps: {
    textValue: 'MUMPS',
    mime: 'text/x-mumps',
  },
  mysql: {
    textValue: 'SQL/mysql',
    mime: 'text/x-mysql',
  },
  nginx: {
    textValue: 'Nginx',
    mime: 'text/x-nginx-conf',
  },
  nsis: {
    textValue: 'NSIS',
    mime: 'text/x-nsis',
  },
  'objective-c': {
    textValue: 'Objective-C',
    mime: 'text/x-objectivec',
  },
  octave: {
    textValue: 'Octave',
    mime: 'text/x-octave',
  },
  oz: {
    textValue: 'Oz',
    mime: 'text/x-oz',
  },
  pascal: {
    textValue: 'Pascal',
    mime: 'text/x-pascal',
  },
  perl: {
    textValue: 'Perl',
    mime: 'text/x-perl',
  },
  pgp: {
    textValue: 'PGP',
    mime: 'application/pgp',
  },
  pgsql: {
    textValue: 'SQL/pgsql',
    mime: 'text/x-pgsql',
  },
  php: {
    textValue: 'PHP',
    mime: 'text/x-php',
  },
  powershell: {
    textValue: 'PowerShell',
    mime: 'application/x-powershell',
  },
  protobuf: {
    textValue: 'ProtoBuf',
    mime: 'text/x-protobuf',
  },
  puppet: {
    textValue: 'Puppet',
    mime: 'text/x-puppet',
  },
  python: {
    textValue: 'Python',
    mime: 'text/x-python',
  },
  q: {
    textValue: 'Q',
    mime: 'text/x-q',
  },
  r: {
    textValue: 'R',
    mime: 'text/x-rsrc',
  },
  restructuredtext: {
    textValue: 'reStructuredText (RST)',
    mime: 'text/x-rst',
  },
  rpm: {
    textValue: 'RPM',
    mime: 'text/x-rpm-spec',
  },
  ruby: {
    textValue: 'Ruby',
    mime: 'text/x-ruby',
  },
  rust: {
    textValue: 'Rust',
    mime: 'text/x-rustsrc',
  },
  sas: {
    textValue: 'SAS',
    mime: 'text/x-sas',
  },
  sass: {
    textValue: 'Sass',
    mime: 'text/x-sass',
  },
  scala: {
    textValue: 'Scala',
    mime: 'text/x-scala',
  },
  scheme: {
    textValue: 'Scheme',
    mime: 'text/x-scheme',
  },
  scss: {
    textValue: 'SCSS',
    mime: 'text/x-scss',
  },
  shell: {
    textValue: 'Shell',
    mime: 'text/x-sh',
  },
  smarty: {
    textValue: 'Smarty',
    mime: 'text/x-smarty',
  },
  solr: {
    textValue: 'Solr',
    mime: 'text/x-solr',
  },
  sparql: {
    textValue: 'SPARQL',
    mime: 'application/sparql-query',
  },
  spreadsheet: {
    textValue: 'Spreadsheet',
    mime: 'text/x-spreadsheet',
  },
  sql: {
    textValue: 'SQL',
    mime: 'text/x-sql',
  },
  sqlite: {
    textValue: 'SQL/SQLite',
    mime: 'text/x-sqlite',
  },
  stex: {
    textValue: 'sTeX',
    mime: 'text/x-stex',
  },
  stylus: {
    textValue: 'Stylus',
    mime: 'text/x-styl',
  },
  swift: {
    textValue: 'Swift',
    mime: 'text/x-swift',
  },
  tcl: {
    textValue: 'Tcl',
    mime: 'text/x-tcl',
  },
  textile: {
    textValue: 'Textile',
    mime: 'text/x-textile',
  },
  tiddlywiki: {
    textValue: 'TiddlyWiki',
    mime: 'text/x-tiddlywiki',
  },
  toml: {
    textValue: 'TOML',
    mime: 'text/x-toml',
  },
  tornado: {
    textValue: 'Tornado',
    mime: 'text/x-tornado',
  },
  troff: {
    textValue: 'Troff',
    mime: 'text/troff',
  },
  typescript: {
    textValue: 'TypeScript',
    mime: 'application/typescript',
  },
  'typescript/jsx': {
    textValue: 'TSX',
    mode: 'javascript',
    mime: 'text/typescript-jsx',
  },
  'vb-net': {
    textValue: 'VB.NET',
    mime: 'text/x-vb',
  },
  vbscript: {
    textValue: 'VBScript',
    mime: 'text/vbscript',
  },
  velocity: {
    textValue: 'Velocity',
    mime: 'text/velocity',
  },
  verilog: {
    textValue: 'Verilog',
    mime: 'text/x-verilog',
  },
  vhdl: {
    textValue: 'VHDL',
    mime: 'text/x-vhdl',
  },
  'vue-js': {
    textValue: 'vue.js',
    mime: 'text/x-vue',
  },
  'web-idl': {
    textValue: 'Web IDL',
    mime: 'text/x-webidl',
  },
  wiki: {
    textValue: 'Wiki',
    mime: 'text/x-wiki',
  },
  xml: {
    textValue: 'XML',
    mime: 'text/xml',
  },
  xquery: {
    textValue: 'XQuery',
    mime: 'application/xquery',
  },
  yaml: {
    textValue: 'YAML',
    mime: 'text/x-yaml',
  },
  webassembly: {
    textValue: 'WebAssembly',
    mime: 'text/webassembly',
  },
}
